import { Button, FlexRow, IconArrow, Input, Label, Stack, Text } from "atoms";
import { ProductWizardStep } from "../ProductWizardStep";
import type { StepProps } from "../../types";

function StepContractAddress({ dispatch, state, moveBack }: StepProps) {
  return (
    <ProductWizardStep
      stepTitle={`${state.productTemplate?.name} Address`}
      state={state}
      moveBack={moveBack}
      nextStep={() => dispatch({ type: "moveNext" })}
    >
      <Stack>
        <Label>
          Address
          <FlexRow flexWrap="nowrap">
            <Input style={{ flex: "1 1 auto" }} />
            <Button>
              Connect <IconArrow />
            </Button>
          </FlexRow>
        </Label>
        <Text size="xs">Not sure what else happens here...</Text>
      </Stack>
    </ProductWizardStep>
  );
}
StepContractAddress.displayName = "Address";

export { StepContractAddress };
